<template>
    <div class="pa-5 compact-form" v-if="activeShop">
        <div v-for="(item, index) in activeShop.codes" :key="item.id">
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Code" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.code"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        @input="updateCodeField($event, 'code', index)"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Partner" | t }}</v-col>
                <v-col cols="6">
                    <v-select
                        :items="partners"
                        :value="item.partner"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        placeholder="Partners"
                        @input="updateCodeField($event, 'partner', index)"
                    />
                </v-col>
            </v-row>
            <v-row class="mr-2" justify="end" no-gutters>
                <v-btn class="px-2" color="bal-red" dark @click.stop="deleteCode(index)">
                    <v-icon>delete</v-icon>
                    {{ "Delete" | t }}
                </v-btn>
            </v-row>
            <v-divider class="my-2" />
        </div>
        <v-btn class="px-2 ml-2" color="bal-red" dark style="min-width: 0;" @click.stop="addNewCode">
            <v-icon>add</v-icon>
            <span>{{ "Add new" | t }}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { availablePartners } from "@/mixins/available-partners";

export default {
    name: "codes-edit-tab",
    computed: {
        ...mapState("ShopsAdminStore", ["activeShop"])
    },
    mixins: [availablePartners],
    methods: {
        ...mapMutations("ShopsAdminStore", ["addNewShopCode", "updateActiveShopCodeProperty", "deleteShopCode"]),
        updateCodeField(value, field, index) {
            this.updateActiveShopCodeProperty({
                prop: field,
                value: value,
                index: index
            });
        },
        addNewCode() {
            this.addNewShopCode();
        },
        deleteCode(index) {
            if (confirm("Are you sure you want to delete this code?")) {
                this.deleteShopCode(index);
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
</style>
